import './App.css';
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Footer from './Components/Footer/Footer';
import Home from './Components/Home/Home';
import Navbar from './Components/Navbar/Navbar';
import Aboutus from './Components/About/Aboutus/Aboutus';
import { useLocation } from "react-router-dom";
import Team from './Components/Team/Team';
import Contact from './Components/Contact/Contact';
import Services from './Components/Servicemain/Servicesmain';
import Chat from './Components/Chat/Chat';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'  
    });
  }, [pathname]);

  return null;
}
function App() {
  return (
    <Router>
      <Navbar />
      <ScrollToTop/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/work" element={<Team/>} />
        <Route path="/contact" element={<Contact/>} />
        <Route path="/services" element={<Services/>} />
      </Routes>
      <Chat/>
      <Footer />
    </Router>
  );
}

export default App;
